export default __webpack_public_path__ + "static/photo_who_we_are-aaa99f15fe2d217e6d0c2125556ec0f4.jpg";